import { Toast } from 'design-system/src/components/Toast/Toast';
import { NewTaskForm } from '../../components/tasks/NewTaskModal';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../auth';
import { useContext } from 'react';
import ExtendedNewTaskForm from '../../components/tasks/ExtendedNewTaskForm';
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
  margin-bottom: 24px;
`;

export default function NewTaskPage() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const extended_inbound_task_flow = authContext?.user?.feature_flags['extended_inbound_task_flow'];
  return (
    <Container>
      <Typography styledAs="h6">Create a new task</Typography>
      {extended_inbound_task_flow ? (
        <ExtendedNewTaskForm
          onSubmit={(taskId: string) => {
            toast.custom(() => <Toast variant="success">Task created.</Toast>);
            navigate(`/tasks/${taskId}`);
          }}
        />
      ) : (
        <NewTaskForm
          onSubmit={(taskId: string) => {
            toast.custom(() => <Toast variant="success">Task created.</Toast>);
            navigate(`/tasks/${taskId}`);
          }}
        />
      )}
    </Container>
  );
}
